{
  "name": "koros-build-client",
  "version": "0.1.0",
  "private": true,
  "type": "module",
  "engines": {
    "node": ">=22"
  },
  "scripts": {
    "dev": "vite",
    "build": "pnpm typecheck && vite build",
    "preview": "vite preview",
    "typecheck": "tsc --noEmit && tsc --noEmit -p tsconfig.sw.json && tsc --noEmit -p tsconfig.node.json && tsc --noEmit -p tsconfig.e2e.json",
    "lint": "eslint .",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "test": "vitest run",
    "test:watch": "vitest",
    "i18n:extract": "node scripts/i18n-extract.mjs",
    "i18n:check": "node scripts/i18n-extract.mjs --check",
    "e2e": "playwright test",
    "backoffice:css": "tailwindcss -i backoffice/tailwind.css -o ../koros-build-api/korosbuild/backoffice/static/backoffice/backoffice.css --minify"
  },
  "dependencies": {
    "@fontsource/archivo": "^5.3.0",
    "@fontsource/inter": "^5.3.0",
    "@fontsource/jetbrains-mono": "^5.3.0",
    "@fontsource/noto-sans-arabic": "^5.3.0",
    "@hookform/resolvers": "^5.9.1",
    "@radix-ui/react-alert-dialog": "^1.1.23",
    "@radix-ui/react-checkbox": "^1.3.11",
    "@radix-ui/react-dialog": "^1.1.23",
    "@radix-ui/react-dropdown-menu": "^2.1.24",
    "@radix-ui/react-label": "^2.1.15",
    "@radix-ui/react-popover": "^1.1.23",
    "@radix-ui/react-separator": "^1.1.15",
    "@radix-ui/react-slot": "^1.3.3",
    "@radix-ui/react-switch": "^1.3.7",
    "@radix-ui/react-tabs": "^1.1.21",
    "@radix-ui/react-tooltip": "^1.2.16",
    "@tanstack/react-query": "^5.104.1",
    "@tanstack/react-router": "^1.170.41",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cmdk": "^1.1.1",
    "dexie": "^4.4.6",
    "dexie-react-hooks": "^4.4.0",
    "fake-indexeddb": "^6.2.5",
    "flag-icons": "^7.5.0",
    "i18next": "^26.4.2",
    "leaflet": "^1.9.4",
    "libphonenumber-js": "^1.13.14",
    "lucide-react": "^1.52.0",
    "react": "^19.3.0",
    "react-dom": "^19.3.0",
    "react-hook-form": "^7.89.0",
    "react-i18next": "^17.0.15",
    "sonner": "^2.0.8",
    "tailwind-merge": "^3.7.0",
    "workbox-core": "^7.4.1",
    "workbox-expiration": "^7.4.1",
    "workbox-precaching": "^7.4.1",
    "workbox-routing": "^7.4.1",
    "workbox-strategies": "^7.4.1",
    "workbox-window": "^7.4.1",
    "zod": "^4.6.5"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.63.0",
    "@tailwindcss/cli": "4.3.3",
    "@tailwindcss/vite": "^4.3.3",
    "@tanstack/router-plugin": "^1.168.42",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.7",
    "@types/leaflet": "^1.9.22",
    "@types/node": "^22.20.5",
    "@types/react": "^19.3.0",
    "@types/react-dom": "^19.3.0",
    "@vitejs/plugin-react": "^6.1.2",
    "eslint": "^10.12.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.5.7",
    "globals": "^17.13.0",
    "jsdom": "^30.1.2",
    "msw": "^2.15.0",
    "prettier": "^3.9.9",
    "prettier-plugin-tailwindcss": "^0.8.1",
    "tailwindcss": "^4.3.3",
    "tw-animate-css": "^1.4.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.71.1",
    "vite": "^8.3.2",
    "vite-plugin-pwa": "^2.0.0",
    "vitest": "^5.0.3"
  },
  "packageManager": "pnpm@12.4.1"
}
